import {Component, Inject, OnInit} from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
  MatIconRegistry,
  MatSnackBar, MatTabGroup,
  MatTreeNestedDataSource
} from '@angular/material';
import {DialogData} from "../../partner-onboard/partner-onboard.component";
import {LeftpanelComponent, ViewRawComponent} from "../../leftpanel/leftpanel.component";
import {ConfService} from "../../conf.service";

@Component({
  selector: 'app-show-job-logs',
  templateUrl: './show-job-logs.component.html',
  styleUrls: ['./show-job-logs.component.scss']
})
export class ShowJobLogsComponent implements OnInit {

  constructor(
      public dialogRef: MatDialogRef<ShowJobLogsComponent>,
      public dialog: MatDialog,
      // public confpost: ConfService,
      // public platform: LeftpanelComponent,
      @Inject(MAT_DIALOG_DATA) public job: any
  ) {}

  ngOnInit() {
    // if (!this.job.hasOwnProperty('history_logs')) {
    //   this.loading = true;
    //   this.confpost.getData('services', 'services', 'v1', 'schedulerLogs', 'event=EVENT_JOB_EXECUTED&details.job_id.in=' + this.job['job_meta']['id']).subscribe(response => {
    //     this.job['history_logs'] = response;
    //     console.log(this.job['history_logs']);
    //     this.loading = false;
    //   }, error => {
    //     this.platform.handleErrorGracefully(error, 'Error while retrieving scheduler logs. Please try again after sometime.');
    //   });
    // }
  }
  close() {
    this.dialogRef.close();
  }

  getMessage(responseObject) {
    if (responseObject['body'] && responseObject['body'][0] && responseObject['body'][0].hasOwnProperty('body')) {
      return responseObject['body'][0]['body'];
    } else {
      return '';
    }
  }
  viewRaw(obj) {
    const rawDialog = this.dialog.open(ViewRawComponent, {
      width: '60%',
      data: {
        title: 'Raw Data',
        JSON: obj
      }
    });
  }
}
